import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { DocumentTemplateService } from '../../../../../../../../services/document-template/document-template.service';

export type DocumentEmailKind = 'expiring_soon' | 'expired';

@Component({
  selector: 'app-preview-document-email-modal',
  templateUrl: './preview-document-email-modal.component.html',
  styleUrls: ['./preview-document-email-modal.component.css']
})
export class PreviewDocumentEmailModalComponent implements OnInit {
  @Input() documentTemplateId: number;
  @Input() emailKind: DocumentEmailKind;
  @Input() text: string;
  @Input() includeButton: boolean;
  @Input() buttonText: string;
  // Only used when emailKind is 'expiring_soon'.
  @Input() leadDays: number;

  public loading = false;
  public errorMessage = '';

  public subject = '';
  public htmlContent = '';

  constructor(
    public activeModal: NgbActiveModal,
    private documentTemplateService: DocumentTemplateService
  ) {}

  get title(): string {
    return (this.emailKind === 'expired')
      ? 'Expired Document Email Preview'
      : 'Expiration Reminder Email Preview';
  }

  ngOnInit() {
    this.loading = true;

    const preview = (this.emailKind === 'expired')
      ? this.documentTemplateService.previewExpiredEmail(
          this.documentTemplateId,
          this.text,
          this.includeButton,
          this.buttonText
        )
      : this.documentTemplateService.previewExpiringSoonEmail(
          this.documentTemplateId,
          this.text,
          this.includeButton,
          this.leadDays,
          this.buttonText
        );

    preview
      .then(result => {
        this.subject = result.subject;
        this.htmlContent = result.html_content;
      })
      .catch(reason => {
        if (reason.error?.useful_error_message) {
          this.errorMessage = reason.error.useful_error_message;
        } else {
          this.errorMessage = 'Failed to load email preview.';
        }
      })
      .finally(() => { this.loading = false; });
  }
}
